// extracted by mini-css-extract-plugin
export default {"container":"f48o","mainContentWrapper":"zF2j","nameAndDatesWrapper":"CADD","detailsBtn":"qj9N","dateWrapper":"eaMH","descriptionWrapper":"ASlj","containerBlured":"gE7Z"};